import { svg } from "@opentiny/vue-common";
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve"
    }
  }, _vm.$listeners), [_c("path", {
    staticClass: "chevron-left_svg__st0",
    attrs: {
      "d": "M17 21c-.2 0-.5-.1-.6-.2l-9.9-8c-.4-.2-.5-.5-.5-.8 0-.3.1-.6.4-.8l9.9-7.9c.4-.4 1.1-.3 1.4.2.4.4.3 1.1-.2 1.4L8.7 12l8.9 7.2c.4.4.5 1 .2 1.4-.3.3-.5.4-.8.4z"
    }
  })]);
};
var ChevronLeft = {
  render
};
var index = function index2() {
  return svg({
    name: "IconChevronLeft",
    component: ChevronLeft
  })();
};
export {
  index as default
};
